module.exports = __webpack_public_path__ + "static/img/zzsypos.13e8419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/zzsypos.png
// module id = sy1a
// module chunks = 1